import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { coreService } from '../../../../../services/core/core-service';
import { useToast } from '../../../../../hooks/useToast';
import { colors } from '../../../../../theme/colors';
import { Box } from '../components/Box';
import { Rows } from './Row';
import { ILink } from '../../../../../services/types';
import Spinner from '../../../../../componentsV2/Spinner';

import Styles from '../styles';
const { Title, Footer, Content } = Styles;

import StylesManageShareLink from './styles';
import { ManageLinksComponent } from '../components/ManageLinksComponent';
const { Loader } = StylesManageShareLink;

interface Props {
  toGenerateLinks: () => void;
  toLinksDetails: () => void;
  selectLink: (link: ILink & { edit: boolean }) => void;
  clipId: string;
}

export const ManageShareLink: React.FC<Props> = ({
  selectLink,
  toLinksDetails,
  toGenerateLinks,
  clipId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [links, setLinks] = useState<ILink[] | null>(null);

  const { error, success } = useToast();

  const handleInitialFetch = () => {
    setIsLoading(true);
    coreService
      .getAllClipShareLinks(clipId)
      .then(res => {
        setLinks(res.links);
      })
      .catch(err => error(err.message))
      .finally(() => setIsLoading(false));
  };

  const handleCancelLink = async (id: string) => {
    setIsLoading(true);
    try {
      await coreService.cancelShareLink(id);
      await handleInitialFetch();
      success('Link has been deactivated.');
    } catch {
      error('An error occurred while canceling the link. Please try again.');
      setIsLoading(false);
    }
  };

  const handelCancelAllLinks = async () => {
    setIsLoading(true);
    try {
      await coreService.cancelAllClipShareLinks(clipId);
      await handleInitialFetch();
      success('All links have been deactivated.');
    } catch {
      error('An error occurred while canceling the links. Please try again.');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleInitialFetch();
  }, []);

  return (
    <>
      <Title>Manage Share Links</Title>

      <Content>
        {isLoading ? (
          <Loader>
            <Spinner animation="grow" color={colors.primary[500]} />
          </Loader>
        ) : (
          <Box
            title="Active Share Links"
            action={
              <Button
                size="small"
                ghost
                style={{ color: 'red' }}
                onClick={handelCancelAllLinks}
                disabled={links?.length === 0}
              >
                Deactivate all links
              </Button>
            }
          >
            <Rows
              list={links}
              selectLink={l => {
                selectLink(l);
                toLinksDetails();
              }}
              cancelLink={id => handleCancelLink(id)}
            />
          </Box>
        )}
      </Content>

      <Footer>
        <ManageLinksComponent />
        <Button onClick={toGenerateLinks}>Go to Generate New Link</Button>
      </Footer>
    </>
  );
};
